<template>  
  <div>
      <q-list-header class="text-weight-bold">{{title}}</q-list-header>
      <div class="dialog">
        <img class="on-right" :src="'data:image/png;base64,' + picture" @click="showPic(Entity.IdEvent)">
        <p></p> 
        <q-datetime :readonly="true" v-model="eventTime" type="datetime" :float-label="$t('global.EventTime')" format="D.MMM.YYYY HH:mm" />
        <q-input v-if="eventText != '' || this.Entity.process == false" :readonly="this.Entity.process" v-model="eventText" rows="2" :float-label="$t('global.Comment')" type="textarea" />
        <q-select
            v-model="selectedType" 
            :float-label="$t('global.EventType')"
            :options="selectOptions"
        />
        <q-input v-if="qrCode" v-model="qrCode" :readonly="true" rows="2" float-label="QR Scan" type="textarea" />            
         
        <q-input class="comment" v-if="this.Entity.process && markProcessed == true" v-model="eventProcessText" rows="2" :float-label="$t('global.Comment')" type="textarea" />  
        
        <q-checkbox v-if="this.Entity.process" class="content" v-model="markProcessed" :label="$t('global.MarkAsProcessed')" />
        <br>
        <q-btn class="dialog" color="negative" v-on:click="cancelRequest">{{$t('global.Cancel')}}</q-btn>
        &nbsp;
        <q-btn 
            class="dialog" 
            color="positive" 
            :loading="loading"
            v-on:click="sendRequest">
             {{$t('global.Save')}}
        </q-btn>
    </div>
    <q-modal v-model="opened" maximized>
        <div style="padding: 10px">
        <q-btn color="primary" @click="opened = false" :label="$t('global.Close')" />
        <p></p>
        <div class="row">
            <div class="col-12">
            <img class="responsive" :src="bigPic">
            </div>
        </div>
        
        </div>
    </q-modal>
 </div>
</template>

<script>
import { Cookies } from 'quasar'
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'SideDialog2',
  data () {
    return {
      title: '',
      event: null,
      selectOptions: [],
      selectedType: null,
      eventText: '',
      eventProcessText: 'test test',
      eventTime: null,
      qrCode: null,
      picture: null,
      form: {
        SessionId: null,
        action: 'SendPic',
      },
      loading: false,
      bigPic: null,
      picCache: [],
      opened: false,
      markProcessed: true
    }
  },
  props: ['Entity'],
  mounted() {
    this.loadEventType()
    this.loadEvent()
  },
  methods: {
    cancelRequest () {
            this.$q.notify('Aenderung wurde nicht gespeichert.')
            this.selectedCapture = null
            this.eventProcessText = ''
            eventBus.$emit('closeDialog', null)
    },
    loadEvent () {
    if(this.Entity.process){
        this.title = this.$t('global.ProcessEvent')
    }
    else{
        this.title = this.$t('global.EditEvent')
    }
    this.form.SessionId = this.$store.state.session.SessionId
    this.form.action = "GetEvent"
    this.form.IdEvent = this.Entity.IdEvent
    axios.post(this.$apiUrl,
    qs.stringify(this.form),
    {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then(response => {
        console.log(response)
        if(response.status == 200){ 
            this.eventText = response.data.Comment
            //this.eventTime = response.data.Created
            this.eventTime = this.moment(response.data.Created).format('YYYY-MM-DDTHH:mm:ss.sssZ')
            this.selectedType = response.data.IdEventType
            this.qrCode = response.data.QrCode
            this.picture = response.data.Thumbnail
            this.eventProcessText = response.data.CommentProcessed
        }
        else{
            this.$q.notify('ERROR')
        }
    })
    .catch(e => {        
      this.$q.notify('ERROR')      
      console.log(e);
    })
    },
    loadEventType () {
    this.form.SessionId = this.$store.state.session.SessionId
    this.form.action = "GetEventTypes"
    axios.post(this.$apiUrl,
    qs.stringify(this.form),
    {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then(response => {
        console.log(response)
        if(response.status == 200){ 
            this.selectOptions = response.data
        }
        else{
            this.$q.notify('ERROR')
        }
    })
    .catch(e => {        
      this.$q.notify('ERROR')      
      console.log(e);
    })
    },

    sendRequest () {
      this.loading = true
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "ProcessEvent"
      this.form.Comment = this.eventText
      this.form.CommentProcessed = this.eventProcessText
      this.form.IdEventType = this.selectedType
      this.form.Processed = this.markProcessed
     
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          console.log(response)
          this.loading = false
          if(response.status == 200){ 
              if(response.data == 'OK'){
                this.$q.notify({ message: this.$t('global.WorkChanged'), type: 'positive' })
                this.selectedCapture = null
                this.eventText = ''
                this.qrScan = null
                eventBus.$emit('closeDialog', null)
                eventBus.$emit('addEvent', null)
              }
              else{
              }
          }
          else{
              this.$q.notify('ERROR')
          }
      })
      .catch(e => {  
         this.loading = false      
        this.$q.notify('ERROR')      
        console.log(e);
      })
    },
        showPic(IdEvent){
      if(this.picCache[IdEvent] == undefined){
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "getCustomerPic"
        this.form.IdEvent = IdEvent
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
                this.bigPic = 'data:image/png;base64,' + response.data
                this.opened = true
                this.picCache[IdEvent] = this.bigPic

            }
            else{
                this.$q.notify('ERROR')
            }
        })
        .catch(e => {
          this.$q.notify('ERROR')
          console.log(e);
        })
      }
      else{
        this.bigPic = this.picCache[IdEvent]
        this.opened = true
      }
    }
  },
  watch: {
    Entity: function (val) {
      this.loadEvent()
      this.eventProcessText = ''

    },
  },
}
function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}


</script>

<style scoped>
    .comment{
      background-color:lightgray;
    }
    .dialog{
        padding: 5px;
    }
</style>